import { useCallback } from "react";
import TagManager from "react-gtm-module";

import { CD_LANGUAGE } from "./useBHCustomEventAnalyticsCall";

export function useBHVirtualPVAnalyticsCall() {
  const analyticsCall = useCallback(
    (
      title: string,
      cd_language?: CD_LANGUAGE,
      at?: string,
      visitorcat?: 1 | 2 | undefined,
      pagination?: number,
    ) => {
      TagManager.dataLayer({
        dataLayer: {
          event: "virtual_pv",
          title: title,
          ...(cd_language && { cd_language: cd_language }),
          ...(at && { at: at }),
          ...(visitorcat && { visitorcat: visitorcat }),
          ...(pagination && { pagination: pagination }),
        },
      });
    },
    [],
  );

  return analyticsCall;
}
